import { useNavigate } from "@tanstack/react-router";
import { getRouteApi } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { authClient, sessionQueryOptions } from "./client";

const routeApi = getRouteApi("/_authenticated");

/** Authenticated route-context selectors; valid only under `/_authenticated` children. */
export function useSession() {
  return routeApi.useRouteContext().session;
}

export function useUser() {
  return routeApi.useRouteContext().user;
}

export function useAuth() {
  return routeApi.useRouteContext().actor;
}

/** Logs out, clears cached session/query state, then navigates to `/login`. */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return async () => {
    await authClient.signOut();
    await queryClient.invalidateQueries();
    queryClient.removeQueries({ queryKey: sessionQueryOptions.queryKey });
    await navigate({ to: "/login" });
  };
}
